
import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { meverProducts, meverCategories } from '../../../mocks/meverProducts';
import { Link } from 'react-router-dom';

export default function MeverProductGrid() {
  const [activeCategory, setActiveCategory] = useState('all');
  const { ref, isVisible } = useScrollAnimation();

  const filteredProducts = activeCategory === 'all'
    ? meverProducts
    : meverProducts.filter(p => p.category === activeCategory);

  return (
    <section ref={ref} className="py-28 lg:py-36 px-8 lg:px-32 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Category Filter */}
        <div className={`flex flex-wrap gap-3 mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          {meverCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                activeCategory === cat.id
                  ? 'bg-gray-900 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {/* Wrapped the slash in a span to avoid parsing issues */}
              {cat.labelJa} <span>/</span> {cat.label}
            </button>
          ))}
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {filteredProducts.map((product, index) => (
            <Link
              to={`/mever/${product.id}`}
              key={product.id}
              className={`group bg-gray-50 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-500 hover:-translate-y-1 cursor-pointer ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: isVisible ? `${index * 100 + 200}ms` : '0ms' }}
            >
              <div className="w-full h-80 overflow-hidden bg-white">
                <img
                  src={product.image}
                  alt={product.nameEn}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-8">
                <p className="text-xs uppercase tracking-wider text-gray-400 mb-3">{product.category}</p>
                <h3 className="text-lg font-medium text-gray-900 mb-1">{product.nameJa}</h3>
                <p className="text-sm text-gray-500 mb-4">{product.nameEn}</p>
                <p className="text-base font-medium text-gray-900">{product.price}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
